import { MedicalType } from "@qendo/medical/types";
import { OptionType } from "@qendo/types";
import { Stack, useLocalSearchParams } from "expo-router";
import { useMemo } from "react";
import { View } from "react-native";
import { DeleteMedicalButton } from "~/components/form/health-profile/DeleteMedicalButton";
import { HeaderButton } from "~/components/HeaderButton";
import { DataList } from "~/components/layout/DataList";
import { DataListItem } from "~/components/layout/DataListItem";
import { BasicGallery } from "~/components/layout/gallery/BasicGallery";
import { Page } from "~/components/layout/Page";
import { Subtitle, Title } from "~/components/layout/text";
import { Authorize } from "~/components/permission/Authorize";
import { Can } from "~/components/permission/Can";
import { Dismiss } from "~/components/permission/Dismiss";
import { Flex, Gap, Items, Padding } from "~/constants/layout";
import { useMedical } from "~/providers/MedicalProvider";
import { useOptions } from "~/providers/OptionsProvider";

const type = MedicalType.trigger;

export default function TriggerDetails() {
    const { id }: { id: string } = useLocalSearchParams();
    const { findMedical } = useMedical();
    const { findOption } = useOptions();
    const trigger = useMemo(() => findMedical(type, id), [id, findMedical]);

    if (!trigger) {
        return <Dismiss />;
    }

    const option = findOption(OptionType.triggers, trigger.option_id);

    return (
        <Authorize ability="view" section="triggers">
            <Stack.Screen
                options={{
                    title: "Trigger details",
                    headerRight: () => (
                        <Can ability="update" section="triggers">
                            <HeaderButton
                                title="Edit"
                                href={{ pathname: "/health-profile/triggers/[id]/edit", params: { id } }}
                            />
                        </Can>
                    ),
                }}
            />
            <Page spacer>
                <View style={[Padding.top_md, Gap.lg, Flex.flex]}>
                    <View style={[Items.start, Gap.xs]}>
                        {option ? <Title size="xl">{option.title}</Title> : null}
                        {trigger.known ? <Subtitle>Known trigger</Subtitle> : null}
                    </View>
                    <DataList>
                        <DataListItem title="Description" data={trigger.description} />
                    </DataList>
                    <BasicGallery images={trigger.photograph_ids} />
                </View>
                <DeleteMedicalButton type={type} id={id} />
            </Page>
        </Authorize>
    );
}
